export const activityLogType = {
  template: 10018,
  group: 10019,
}
